const en = {
  // Sidebar navigation
  nav_dashboard: 'Dashboard',
  nav_optimizer: 'Optimizer',
  nav_builder: 'Portfolio Builder',
  nav_compare: 'Compare',
  nav_performance: 'Performance',
  nav_market: 'Market Data',
  nav_stocks: 'Stock Comparison',
  nav_planning_hub: 'Financial Planning Hub',
  nav_concepts_library: 'Concepts Library',
  nav_growth_forecast: 'Growth Forecast',
  nav_goal_planner: 'Goal Planner',
  nav_retirement: 'Retirement',
  nav_learning_center: 'Learning Center',
  nav_portfolio_optimization: 'Portfolio Optimization',
  nav_watchlist: 'Watchlist',
  nav_alerts: 'Alerts',
  nav_goals: 'Goals',
  nav_help: 'Help',
  nav_contact: 'Contact',
  nav_mission: 'Mission',
  nav_mission_planning: 'Planning Mission',
  nav_admin: 'Admin',
  nav_sign_out: 'Sign Out',
  nav_sign_in: 'Sign In',
  nav_register: 'Register',
  nav_guest: 'Guest Mode',
  nav_group_planning: 'Financial Planning',
  nav_group_advanced_tools: 'Advanced Tools',
  nav_group_monitoring: 'Monitoring',
  nav_group_reference: 'Reference',
  nav_start_here: 'Start Here',
  nav_learn_accounts: 'Learn Accounts',
  nav_learn_investing: 'Learn Investing',
  nav_set_goal: 'Set a Goal',
  nav_forecast_growth: 'Forecast Growth',
  nav_retirement_planning: 'Retirement Planning',
  nav_planning_principles: 'Planning Principles',
  nav_portfolio_analytics: 'Portfolio Analytics',
  nav_asset_research: 'Asset Research',
  nav_comparison_tools: 'Comparison Tools',
  nav_stock_comparison: 'Stock Comparison',
  nav_portfolio_home: 'Portfolio Home',
  topbar_planning_hub: 'Financial Planning Hub',
  topbar_portfolio_toolkit: 'Portfolio Toolkit',
  sidebar_tagline: 'Canadian. Independent. Focused on you.',

  // Common actions
  btn_save: 'Save',
  btn_cancel: 'Cancel',
  btn_create: 'Create',
  btn_delete: 'Delete',
  btn_export: 'Export CSV',
  btn_generate: 'Generate Portfolio',
  btn_add: 'Add',
  btn_check: 'Check',
  btn_new: 'New',
  btn_edit: 'Edit',
  btn_share: 'Share',
  btn_refresh: 'Refresh',

  // Dashboard
  dash_title: 'Portfolio Command Center',
  dash_welcome: 'Welcome back',
  dash_kpi_portfolio_value: 'Projected Portfolio Value',
  dash_kpi_gain_loss: 'Projected Gain/Loss',
  dash_kpi_portfolios: 'Active Portfolios',
  dash_kpi_sp500: 'S&P 500 Return',
  dash_section_performance: 'Performance',
  dash_section_holdings: 'Top Holdings',
  dash_section_activity: 'Recent Activity',
  dash_section_saved: 'Saved Portfolios',
  dash_no_portfolios: 'No portfolios yet.',

  // Portfolio Generator
  pg_title: 'Portfolio Generator',
  pg_subtitle: 'Build a diversified portfolio based on your risk profile and constraints',
  pg_section_params: 'Portfolio Parameters',
  pg_label_persona: 'Portfolio Persona',
  pg_label_investment: 'Investment Amount',
  pg_label_min_holdings: 'Min Holdings',
  pg_label_max_holdings: 'Max Holdings',
  pg_label_max_position: 'Max Position (%)',
  pg_label_max_sector: 'Max Sector (%)',
  pg_label_include_etfs: 'Include ETFs',
  pg_label_include_bonds: 'Include Bonds',
  pg_results_title: 'Portfolio Results',
  pg_asset_dist: 'Asset Type Distribution',
  pg_sector_dist: 'Sector Distribution',
  pg_metrics_title: 'Portfolio Metrics',

  // Market Data
  md_title: 'Market Database',
  md_subtitle: 'Browse and filter stocks using fundamental and quantitative metrics',
  md_search_placeholder: 'Search ticker or company name...',
  md_filter_exchange: 'Exchange',
  md_filter_sector: 'Sector',
  md_all_exchanges: 'All Exchanges',
  md_all_sectors: 'All Sectors',
  md_research_title: 'Research one asset at a time',
  md_research_subtitle: 'Search first, then open fundamentals, price history, and advanced valuation details only when useful.',
  md_price_data_as_of: 'Price data as of',
  md_tickers_latest_date: 'tickers at latest date',
  md_browse_stocks_title: 'Browse stocks',
  md_browse_stocks_subtitle: 'Find the security you want to understand',
  md_showing_count: 'Showing {{shown}} of {{total}} stocks',
  md_search_asset_begin: 'Search for an asset to begin',
  md_choose_from_count: 'Choose from {{count}} stocks in your database, then open details progressively.',

  // Watchlist
  wl_title: 'Watchlist',
  wl_subtitle: 'Track your favorite stocks and monitor their performance.',
  wl_add_stock: 'Add Stock',
  wl_no_stocks: 'No stocks in your watchlist yet.',

  // Goals
  goals_title: 'Goals & Targets',
  goals_new: 'New Goal',
  goals_explainer_title: 'What are Goals?',
  goals_no_goals: 'No goals yet.',

  // Alerts
  alerts_title: 'Price Alerts',
  alerts_new: 'New Alert',
  alerts_no_alerts: 'No alerts set.',

  // Performance
  perf_title: 'Performance Dashboard',

  // Compare
  cmp_title: 'Portfolio Comparison',
  cmp_subtitle: 'Select portfolios to compare side-by-side',

  // Help
  help_title: 'Help & FAQ',
  help_subtitle: 'Learn about the platform, financial concepts, and how to get the most out of your portfolio analytics.',

  // Auth
  auth_login_title: 'Sign In',
  auth_register_title: 'Create Account',
  auth_email: 'Email',
  auth_password: 'Password',
  auth_confirm_password: 'Confirm Password',
  auth_or_guest: 'or continue as guest',

  // Status
  status_loading: 'Loading...',
  status_saving: 'Saving...',
  status_saved: 'Saved.',
  status_error: 'An error occurred.',
  status_no_data: 'No data available.',

  // App shell
  app_subtitle: 'Educational planning and scenario modeling for Canadian households.',
  app_planning_subtitle: 'Beginner-first guidance for registered accounts, goals, and retirement scenarios.',
  app_optimization_subtitle: 'Streamlined portfolio optimization tools with less clutter and clearer workflows.',
  workspace_open_optimization: 'Open Portfolio Optimization',
  workspace_open_planning: 'Open Financial Planning Hub',
  workspace_planning_title: 'Financial Planning Workspace',
  workspace_optimization_title: 'Portfolio Optimization Workspace',
  workspace_planning_subtitle: 'Beginner-friendly tools for accounts, goals, and retirement decisions.',
  workspace_optimization_subtitle: 'Focused analytics for building, optimizing, and tracking portfolios.',
  api_notice_health_degraded: 'Some live data features are temporarily delayed. Please wait about 30–90 seconds while the service reconnects, then try again.',
  api_notice_rate_limit: 'We’re processing a lot of requests right now. Please wait about 30–60 seconds and try again.',
  api_notice_timeout: 'The live data service is taking longer than usual. Please wait about 30–90 seconds and try again — your session and saved portfolios are still safe.',
  api_notice_reconnect: 'We’re having trouble reaching the analytics service right now. Please wait about 30–90 seconds while it reconnects, then try again.',
  api_notice_busy: 'The analytics engine is temporarily busy. Please wait about 30–90 seconds and retry your request.',
};

export default en;
